module.exports = __webpack_public_path__ + "static/img/SDC300应用场景-人工智能.42aa7f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-2/SDC300应用场景-人工智能.png
// module id = G2Uk
// module chunks = 0